module.exports = __webpack_public_path__ + "img/today-portrait.25084435.jpg";